// extracted by mini-css-extract-plugin
export default {"Picture":"slJnKPGAAIKofsQwQBjL","Variant--rounded":"vPKYJ9xnnqorRitmkm3i"};